// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ArticleMenu__icon{height:1.625rem!important;width:1.25rem!important}.ArticleMenu__icon>path{fill:none!important;stroke:#7cb342!important}.ArticleMenu>.VerticalMenuCard>.VerticalMenuItem--level1{border-top:1px solid #7cb342}.ArticleMenu>.VerticalMenuCard>.VerticalMenuItem--level1~.VerticalMenuItem--level1{border-top:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
